<template>
  <div class="safety">
    <div
      class="safety__items"
      :class="{ 'safety__items--centered': !duplicate }"
    >
      <div class="safety__items-item">
        <safety-drop
          name="product"
          :label="configs.ProductLabel"
          :items="products"
          :selected="configs.ButtonLabel"
          :active="true"
          @changed="updateProduct"
        />
        <safety-drop
          ref="countryDrop"
          name="country"
          :label="configs.CountryLabel"
          :items="countries"
          :selected="configs.ButtonLabel"
          :active="product != null"
          @changed="updateCountry"
        />
        <safety-drop
          ref="languageDrop"
          name="language"
          :label="configs.LanguageLabel"
          :items="languages"
          :selected="configs.ButtonLabel"
          :active="country != null"
          @changed="updateLanguage"
        />
        <safety-file
          :button="configs.ButtonDownloadLabel"
          :file="file"
          :active="language != null"
          @click="pushGTM"
        />
      </div>
    </div>
  </div>
</template>

<script>
import SafetyDrop from './safety-drop.vue'
import SafetyFile from './safety-file.vue'

export default {
  name: 'safety-datasheet',
  components: {
    SafetyDrop,
    SafetyFile,
  },
  props: {
    datasource: {
      type: Object,
    },
    duplicate: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      product: null,
      country: null,
      language: null,
      products: [],
      configs: {
        ButtonLabel: 'undefined',
        ProductLabel: 'undefined',
        CountryLabel: 'undefined',
        LanguageLabel: 'undefined',
        ButtonDownloadLabel: 'undefined',
      },
    }
  },
  computed: {
    countries() {
      return this.product && this.product.SafetyDatasheetCountries
        ? this.product.SafetyDatasheetCountries
        : []
    },
    languages() {
      return this.country && this.country.SafetyDatasheetLanguages
        ? this.country.SafetyDatasheetLanguages
        : []
    },
    file() {
      return this.language ? this.language.SafetyDatasheetFile : null
    },
  },
  created() {
    if (this.datasource.Products) {
      this.products = this.datasource.Products
    }
    if (this.datasource.SafetyDatasheetSettings) {
      this.configs = this.datasource.SafetyDatasheetSettings
    }
  },
  methods: {
    updateProduct(newValue) {
      this.product = newValue
      this.$refs.countryDrop.clearSelection()
    },
    updateCountry(newValue) {
      this.country = newValue
      this.$refs.languageDrop.clearSelection()
    },
    updateLanguage(newValue) {
      this.language = newValue
    },
    pushGTM() {
      const getProduct = this.product?.Product?.Title
      const getCountry = this.country?.Country?.Title
      const getLanguage = this.language?.DocumentLanguage?.Title
      const getButtonLabel = this.configs?.ButtonDownloadLabel
      const getUrl = this.file?.Url

      window.dataLayer.push({
        event: 'SD_sheets',
        product: getProduct || '',
        country: getCountry || '',
        language: getLanguage || '',
        label: getButtonLabel || '',
        url: getUrl || ''
      })
    }
  },
}
</script>
